import { isDev } from "@memorang/constants/src/urls";
import { baseNextjsUrl } from "@memorang/constants/src/urls";

export const urls = {
	core: "https://memorang.com",
	dev: "http://localhost:8081",
};

export const ENDPOINT_FEEDBACK = `${baseNextjsUrl}/api/ai/submissions`;
export const ENDPOINT_EXAM_CONTEXT = `${baseNextjsUrl}/api/ai/exam-context`;
export const ENDPOINT_HINT = `${baseNextjsUrl}/api/ai/hint`;
export const ENDPOINT_GENERATE_EXPLANATION = `${baseNextjsUrl}/api/ai/assessment`;
export const ENDPOINT_GENERATE_EXPLANATION_FOR_RECORDING = `${baseNextjsUrl}/api/ai/generate-explanation`;
export const ENDPOINT_CACHE = `${baseNextjsUrl}/api/cache`;
export const API_BASE_URL = isDev
	? "https://beta.api.memorang.io"
	: "https://prod.api.memorang.io";

export const JBJS_FULL_ARTICLE_URL =
	"https://www.jbjs.org/reader.php?rsuite_id=";
export const ENDPOINT_ASSESSOR = `${baseNextjsUrl}/api/ai/graphs/assessor`;
export const ENDPOINT_ONBOARDING_GOAL = `${baseNextjsUrl}/api/ai/onboarding-goal`;
